<template>
  <v-dialog
    v-model="upgradeDialog"
    width="500"
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        v-if="step == 'almost-done'"
      >
        <v-layout
          wrap
          justify-center
        >
          <v-flex
            text-center
            mt-10
            mb-10
          >
            <v-progress-circular
              :size="40"
              color="primary"
              class="mb-2"
              indeterminate
            /><br>
            <b>{{ $t('packs.almostDone') }}</b>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-text
        v-if="step == 'choose-pack'"
      >
        <div v-if="!hidePacks">
          <span class="step-title">{{ $t('packs.chooseRightPack') }}</span>
          <p class="mt-3 mb-0">
            {{ $t('packs.lifeTypeUsage') }}
          </p>
        </div>
        <packs
          :is-partner="true"
          :is-partner-checked="isPartnerChecked"
          :hide-packs="hidePacks"
          @setProducts="setProducts"
        />
      </v-card-text>
      <v-card-text
        v-if="step == 'accept-terms'"
      >
        <accept-terms
          @acceptTerms="acceptTerms"
        />
      </v-card-text>
      <v-card-text
        v-if="step == 'gateways'"
      >
        <gateways
          :invoice-id="invoice.id"
          @closeDialog="closeDialog"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>

import AcceptTerms from "@/views/Packs/partial/AcceptTerms.vue";
import Packs from "@/views/Packs/partial/Packs.vue";
import Gateways from "@/views/Gateway/partial/Gateways.vue";

import CREATE_ORDER_MUTATION from '@/graphql/mutations/CreateOrder.gql';
import { mapMutations, mapGetters } from "vuex";

export default {
  name: 'HelperPlanWizard',
  components: {
    Packs,
    AcceptTerms,
    Gateways
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    hidePacks: {
      type: Boolean,
      default: false
    },
    isPartnerChecked: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false,
    step: 'choose-pack',
    termsAccepted: false,
    invoice: null,
    products: []
  }),
  computed: {
    ...mapGetters("invoice", ["getPending"]),
    upgradeDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeUpgradeDialog", val);
      }
    },
  },
  methods: {
    ...mapMutations("invoice", ["setPending"]),
    ...mapMutations("app", ["setShowChat"]),
    setProducts(products) {
      this.products = products
      this.buyPack()
    },
    acceptTerms(val) {
      this.termsAccepted = val
      this.step = 'almost-done'
      this.buyPack()
    },
    buyPack() {
      if (!this.termsAccepted) {
        this.step = 'accept-terms'
        return
      }
      this.createOrder()
    },
    createOrder() {
      this.loading = true
      this.$apollo.mutate({
          mutation: CREATE_ORDER_MUTATION,
          variables: {
            product_ids: this.products
          }       
      }).then(data => {       
          this.invoice = data.data.createOrder.invoice
          this.setPending(this.invoice.id)
          this.step = 'gateways';
          this.loading = false; 
      }).catch(error => {
          this.loading = false; 
          this.errorHandler(error) 
      })
    },
    closeDialog() {
      this.upgradeDialog = false
      if (this.getPending != null) {
        this.$tidioChatApi.track("abandoned_payment");
        this.setShowChat(true)
        this.$router.push(`/invoice/${this.getPending}`)
      }
    }
  }
}
</script>

<style lang="scss">
.step-title {
    font-weight: 700;
    font-size: 26px;
  }
</style>